{
  "boxes1": [
    {
      "title": "Mniej absencji",
      "text": "Ograniczysz koszty związane ze zwolnieniami i spadkiem produktywności.",
      "image": {
        "url": "/images/box_1.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Utrzymanie talentów",
      "text": "Zmniejszysz rotację swoich pracowników.",
      "image": {
        "url": "/images/box_2.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Zapobieganie kryzysom",
      "text": "Stworzysz przyjazne środowisko pracy i sprawdzony system wsparcia.",
      "image": {
        "url": "/images/box_3.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Osiąganie celów",
      "text": "Wpłyniesz na efektywność zespołu podnosząc poziom satysfakcji z pracy.",
      "image": {
        "url": "/images/box_4.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes10": [
    {
      "title": "Moduł abonamentów",
      "text": "Intuicyjny i wygodny sposób zarządzania benefitami udostępnianymi przez Twoją firmę. \n Udostępnij benefity od wszystkich dostawców zewnętrznych (takie jak karta sportowa, opieka medyczna, \n czy ubezpieczenie grupowe) swoim pracownikom lub wybranym grupom.",
      "image": {
        "url": "/icons/icon-8.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Struktura Organizacji",
      "text": "Zoptymalizuj koordynację procesów kadrowych i poszerz możliwości w innych modułach MyBenefit. Zyskasz dostęp do wszystkich danych pracowników w jednym miejscu, zwiększysz efektywność pracy działu HR i zaoszczędzisz cenny czas.",
      "image": {
        "url": "/icons/icon-9.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "E-podpis",
      "text": "Usprawnij proces podpisywania dokumentów, zgód, oświadczeń i wniosków dzięki sprawdzonej i bezpiecznej opcji podpisu \n elektronicznego. Digitalizacja na 100% tylko z e-podpisem.",
      "image": {
        "url": "/icons/icon-10.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Wnioski pracownicze",
      "text": "Szybkie i proste wnioskowanie o zapomogi, wczasy pod gruszą czy dofinansowania do żłobka i przedszkola, \n zgodnie z istotnymi dla Ciebie kryteriami. Postaw na wygodę i ekologię, pozbądź się papieru i zdigitalizuj firmowe wnioski.",
      "image": {
        "url": "/icons/icon-11.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Nieobecności",
      "text": "Wygodne składanie i rozpatrywanie wniosków urlopowych, o pracę zdalną i innych. Zautomatyzuj pozyskiwanie danych o nieobecnościach, dzięki czemu ograniczysz ilość formalności i lepiej zaplanujesz pracę zespołu, gdy pracownicy są na urlopie lub zwolnieniu.",
      "image": {
        "url": "/icons/icon-12.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Moduł Wynagrodzeń",
      "text": "Stwórz przejrzysty system wynagrodzeń i przygotuj firmę na nadchodzące zmiany prawne. Zdobądź wsparcie w budowaniu architektury stanowisk i wyznaczaniu ścieżek kariery, redukuj lukę płacową i zwiększaj konkurencyjność firmy jako pracodawcy.",
      "image": {
        "url": "/icons/icon-16.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes11": [
    {
      "title": "Moduł kafeteryjny",
      "text": "Wykorzystaj środki obrotowe lub ZFŚS i przyznawaj pracownikom punkty, które mogą wymieniać na dowolne wybrane \n bony do sklepów oraz kulturalne, turystyczne i sportowe vouchery. Zadbaj o finansowy wellbeing pracowników, dając im wolność wyboru \n dokładnie tego, czego potrzebują w ramach benefitów.",
      "image": {
        "url": "/icons/icon-13.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Baza Wiedzy",
      "text": "Sprawne zarządzanie dokumentami firmowymi, takimi jak instrukcje, prezentacje, czy artykuły​, a także organizacją katalogów i podkatalogów oraz publikacją treści. Zapewnij pracownikom stały dostęp do wiedzy o firmie, zadbaj o aktualność materiałów, usprawnij ich wymianę między zespołami i wesprzyj proces onboardingu.",
      "image": {
        "url": "/icons/icon-14.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Total Reward Statement",
      "text": "Teraz przedstawisz swojemu zespołowi nie tylko zasilenia punktów w kafeterii, ale i benefity takie jak dofinansowanie do obiadów, \n kursy językowe, „owocowe dni”. Zaprezentuj pracownikom ich indywidualną listę świadczeń i podnieś świadomość wartości benefitów \n pozapłacowych w organizacji.",
      "image": {
        "url": "/icons/icon-15.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "System nagradzania",
      "text": "Motywacja prosta jak nigdy. Nagradzaj pracowników na bieżąco punktami w kafeterii. Przekazuj managerom budżety do \n błyskawicznego i indywidualnego doceniania zaangażowania. Przyznawaj nagrody na specjalne okazje – urodziny, jubileusze czy święta \n w firmie.",
      "image": {
        "url": "/icons/icon-17.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Aktualności",
      "text": "Proste w obsłudze narzędzie do zamieszczania ważnych komunikatów firmowych, filtrowania odbiorców i tworzenia grup tematycznych dla pracowników. Zyskaj skuteczny kanał komunikacji z zespołem, ogranicz liczbę maili​ i zapewnij pracownikom przestrzeń do dyskusji i wymiany doświadczeń.",
      "image": {
        "url": "/icons/icon-18.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes12": [
    {
      "title": "Poprawę zdrowia i dobrostanu pracowników",
      "text": "Miej wpływ na kondycję fizyczną i zdrowe nawyki swoich zespołów",
      "image": {
        "url": "/images/boxes/Pic-8.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Zmniejszenie kosztów absencji",
      "text": "Inwestycja w zdrowie i aktywność, to mniej zwolnień i nieobecności",
      "image": {
        "url": "/images/boxes/Pic-9.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Zwiększenie zaangażowania",
      "text": "Troska o dobrostan fizyczny przekłada się na efektywność pracowników",
      "image": {
        "url": "/images/boxes/Pic-10.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Redukcja stresu i jego negatywnych następstw",
      "text": "Zapobiegaj wypaleniu zawodowemu i wzmacniaj kondycję psychiczną zespołu, motywując do aktywności.",
      "image": {
        "url": "/images/boxes/Pic-11.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Wizerunek wspierającego pracodawcy",
      "text": "Buduj przyjazne środowisko pracy, przyciągaj wyjątkowe talenty.",
      "image": {
        "url": "/images/boxes/Pic-12.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    }
  ],
  "boxes13": [
    {
      "title": "Pełne wsparcie użytkownika",
      "text": "Zapewniamy dedykowaną infolinię czynną 7 dni w tygodniu dla pełnej informacji i obsługi Twojej organizacji, dzięki temu \n nie musisz pośredniczyć w kontakcie.",
      "image": {
        "url": "/images/boxes/Pic-13.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Ekspercka dawka wiedzy",
      "text": "Naszą misją jest wspieranie ludzi w drodze do aktywnego i zdrowego stylu życia. Edukujemy w przyjazny sposób m.in. na Instagramie, Facebooku, \n w dedykowanych mailingach i newsletterach, wyzwaniach dla użytkowników.",
      "image": {
        "url": "/images/boxes/Pic-14.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Wizyty międzynarodowe",
      "text": "Jedyna karta sportowa, która pozwoli Twoim pracownikom korzystać z aktywności w Polsce i za granicą. Największa na rynku baza obiektów sprawia, że benefit staje się przydatny na co dzień, na urlopie i w czasie delegacji.",
      "image": {
        "url": "/images/boxes/Pic-15.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Wiedza i motywacja",
      "text": "Treningi dostępne online, materiały wideo dla początkujących oraz treści edukacyjne, motywacyjne i inspiracyjne tworzone przez ekspertów wspierają pracowników w budowaniu aktywnego stylu życia.",
      "image": {
        "url": "/images/boxes/Pic-16.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Doświadczenie wsparte wiedzą",
      "text": "Od ponad 23 lat badamy potrzeby firm i pracowników, dzięki czemu tworzymy najbardziej pożądaną kartę sportową.",
      "image": {
        "url": "/images/boxes/Pic-17.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Doradztwo i obsługa posprzedażowa",
      "text": "Pomożemy dobrać najlepszą ofertę kart sportowych dla Ciebie i Twojego zespołu, przeprowadzimy proces wdrażania \n i elastycznie dopasujemy sposób finansowania rozliczenia środków.",
      "image": {
        "url": "/images/boxes/Pic-18.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes14": [
    {
      "id": 1,
      "title": "Zdrowie",
      "text": "Zadbaj o skuteczną profilaktykę zespołu, dzięki szybkiemu dostępowi do teleporad\n z lekarzem, badań profilaktycznych bez skierowania,\n a także konsultacji z trenerem czy dietetykiem.",
      "image": {
        "url": "/images/boxes/Pic-19.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 2,
      "title": "Rozwój",
      "text": "Zapewnij narzędzia rozwojowe, takie jak kursy językowe, webinary i szkolenia, autorskie programy, dostęp do ebooków i audiobooków oraz wsparcie ekspertów podczas konsultacji z trenerem finansowym i lektorem językowym.",
      "image": {
        "url": "/images/boxes/Pic-20.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 3,
      "title": "Psychologia",
      "text": "Zbuduj mocny i odporny na stres zespół, dzięki dostępowi do regularnych konsultacji\n z psychologiem, aplikacji ułatwiającej wyciszenie i kursom mindfulness.",
      "image": {
        "url": "/images/boxes/Pic-21.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "id": 4,
      "title": "Odżywianie",
      "text": "Porcja zdrowia dla Twojego zespołu: od konsultacji\n z dietetykiem i trenerem, przez przydatne kursy i treningi, aż\n po kreator spersonalizowanej\n diety.",
      "image": {
        "url": "/images/boxes/Pic-22.jpg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ],
  "boxes15": [
    {
      "title": "Absencja i L4 na stres",
      "text": "Zmniejszysz liczbę zwolnień dostarczając usługi wspierające zdrowie psychiczne i fizyczne pracowników",
      "image": {
        "url": "/images/boxes/Pic-23.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Rotacja pracowników",
      "text": "Rozumiejąc potrzeby zespołu i wspierając rozwój osobisty i zawodowy sprawiasz, że ludzie rzadziej myślą o zmianie pracy",
      "image": {
        "url": "/images/boxes/Pic-24.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Niskie zaangażowanie i “cicha rezygnacja”",
      "text": "Pracownicy odczuwający troskę częściej podejmują wysiłki i realizują cele organizacji",
      "image": {
        "url": "/images/boxes/Pic-25.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Symptomy prowadzące do wypalenia",
      "text": "Wspierając odporność zespołu przeciwdziałasz skutkom długotrwałego stresu",
      "image": {
        "url": "/images/boxes/Pic-26.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    }
  ],
  "boxes3": [
    {
      "title": "Wellbeing concierge",
      "text": "Pozwól się wyręczyć w stworzeniu i wdrożeniu efektywnej strategii wellbeingowej i zaufaj ekspertowi, \n który zmierzy poziom dobrostanu, dopasuje rozwiązania i zapewni wsparcie na każdym etapie.",
      "image": {
        "url": "/images/screen_4.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Wellbeing score",
      "text": "Dobrostan staje się mierzalnym wskaźnikiem\n w rękach pracodawców. Zmierz poziom wellbeingu i zacznij działać w kluczowych obszarach wymagających zmiany.",
      "image": {
        "url": "/images/screen_2.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Uznane produkty",
      "text": "Wspieraj dobrostan fizyczny, mentalny\n i finansowy dzięki znanym\n i pożądanym produktom MultiSport, Multi.Life, MyBenefit.",
      "image": {
        "url": "/images/screen_3.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Webinary i warsztaty",
      "text": "Dopasuj tematykę eksperckich szkoleń do potrzeb Twojego zespołu - stacjonarnie\n lub online.",
      "image": {
        "url": "/images/screen_1.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    },
    {
      "title": "Wsparcie ekspertów",
      "text": "Zapewnij pracownikom dostęp do regularnych konsultacji z psychologiem, dietetykiem, trenerem personalnym i finansowym oraz lektorem językowym, dzięki którym zredukują stres, odzyskają równowagę i zrobią krok w kierunku zdrowia.",
      "image": {
        "url": "/images/screen_5.jpg",
        "alternative": "",
        "width": "458",
        "height": "200"
      }
    }
  ],
  "boxes4": [
    {
      "text": "Przystępnie podaną wiedzę ekspercką - Programy szkoleniowe, bibliotekę kursów, konsultacje\n z psychologiem, dietetykiem i trenerem, dostęp do usług wspierających osobiste cele"
    },
    {
      "text": "Regularne raporty - Dashboard\n HR umożliwi wgląd\n w aktualny poziom dobrostanu\n w formie i potrzeby pracowników,\n na które możesz odpowiadać\n na bieżąco"
    },
    {
      "text": "Pełną kontrolę nad rozwiązaniami wellbeingowymi\n z poziomu jednej platformy"
    }
  ],
  "boxes5": [
    {
      "title": "Dla firmy",
      "text": "Platforma umożliwiająca badanie, monitorowanie i podnoszenie poziomu wellbeingu w firmie.",
      "image": {
        "url": "/images/head-1.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    },
    {
      "title": "Dla pracowników",
      "text": "Asystent w drodze do zdrowego życia, dobrego samopoczucia i osiągania osobistych celów.",
      "image": {
        "url": "/images/head-2.png",
        "alternative": "",
        "width": "236",
        "height": "236"
      }
    }
  ],
  "boxes6": [
    {
      "title": "Kompleksowe wsparcie 4 obszarów wellbeingu",
      "text": "Wsparcie jednego obszaru"
    },
    {
      "title": "Personalizacja i elastyczny zakres",
      "text": "Brak personalizacji usług"
    },
    {
      "title": "Dostęp do kilkunastu usług i aplikacji wspierających",
      "text": "Brak dostępów do usług i aplikacji partnerów"
    },
    {
      "title": "Możliwość rozszerzenia o komplementarne produkty: MultiSport, MyBenefit",
      "text": "Dostęp do jednego produktu"
    }
  ],
  "boxes7": [
    {
      "text": "<span>23,8 mln</span> dni opuszczają Polacy rocznie z powodu zaburzeń psychicznych i zaburzeń zachowania, w tym reakcji na stres",
      "subtext": "Raport absencji chorobowej ZUS 2022 r."
    },
    {
      "text": "<span>72% pracowników w Europie</span> to tzw. rezygnujący po cichu, czyli pracownicy, którzy wykonują niezbędne minimum i nie angażują się w swoją pracę",
      "subtext": "Raport State of the Global Workplace 2023"
    }
  ],
  "boxes8": [
    {
      "title": "Aspirujący sportowiec",
      "text": "Zacznij przygodę ze sportem i wypracuj wymarzoną formę dzięki małym krokom.",
      "image": {
        "url": "/images/boxes/box-10.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Metabolizm i kontrola masy ciała",
      "text": "Osiągnij wymarzoną sylwetkę i zyskaj zdrowe, pełne energii ciało, dopasowując dietę do własnych potrzeb.",
      "image": {
        "url": "/images/boxes/box-11.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Zdrowie i jakość życia",
      "text": "Rozpocznij zdrowe i jakościowe życie dbając o dobry sen, poziom energii, satysfakcjonujący wygląd czy życie seksualne.",
      "image": {
        "url": "/images/boxes/box-12.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Inteligencja finansowa",
      "text": "Zapanuj nad budżetem domowym i finansami, ucząc się mądrze inwestować i pomnażać kapitał.",
      "image": {
        "url": "/images/boxes/box-13.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Rozwój osobisty",
      "text": "Pokonaj swoje ograniczenia i rozwijaj się w dowolnym kierunku dzięki prostym nawykom.",
      "image": {
        "url": "/images/boxes/box-14.jpg",
        "alternative": "",
        "width": "362",
        "height": "148"
      }
    },
    {
      "title": "Stres i odporność psychiczna",
      "text": "Obniż poziom stresu i zadbaj o swoje mentalne wsparcie, dzięki skutecznym strategiom selfcare.",
      "image": {
        "url": "/images/boxes/box-15.jpg"
      }
    },
    {
      "title": "Mindfulness i Slow life",
      "text": "Zwolnij i ciesz się życiem, doświadczaj wdzięczności i buduj zdrowe nawyki.",
      "image": {
        "url": "/images/boxes/Pic-27.jpg"
      }
    }
  ],
  "boxes9": [
    {
      "title": "Oszczędność czasu",
      "text": "Uprościsz pracę całego zespołu i skrócisz do minimum niezbędne formalności",
      "image": {
        "url": "/icons/frame-1.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Skuteczne motywowanie",
      "text": "Zaangażujesz zespół dzięki nowoczesnym benefitom, grywalizacji i przyjaznemu nagradzaniu",
      "image": {
        "url": "/icons/frame-2.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Dobrostan finansowy",
      "text": "Wpłyniesz na poczucie bezpieczeństwa i zadowolenie pracowników, dzięki elastycznemu systemowi kafeteryjnemu",
      "image": {
        "url": "/icons/frame-3.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    },
    {
      "title": "Silna organizacja",
      "text": "Dostarczysz nowoczesne narzędzia do efektywnego zarządzania.",
      "image": {
        "url": "/icons/frame-4.svg",
        "alternative": "",
        "width": "56",
        "height": "56"
      }
    }
  ]
}
